// extracted by mini-css-extract-plugin
export default {"avatarListBox":"pc_avatarListBox__T0iCK","avatar":"pc_avatar__TMht8"};